import React, { useState, useEffect } from "react";
import StripePayment from "./Stripe/StripePayment";
import StripeSubscriptionPayment from "./Stripe/StripeSubscriptionPayment";
import StripeProPlanPayment from "./Stripe/StripeProPlanPayment";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";
import gems from "./Assets/ap/1.png";
import fulllife from "./Assets/ap/2.png";
import unlidraw from "./Assets/ap/3.png";
import selfmastery from "./Assets/ap/4.png";
import blessedluck from "./Assets/ap/5.png";
import guidedmeditation from "./Assets/ap/6.png";
import personalizedplan from "./Assets/ap/7.png";
import discountedgem from "./Assets/ap/8.png";
import crown from "./Assets/crown.png";
import image from "./Assets/whaat.png";

const gold = "#DFBD69";

// Free plan Price ID for subscription creation
const FREE_PLAN_PRICE_ID = "price_1Sa9hiH4SEOW1T3dP1pkxoOR";
// Responsive style factory (phone / tablet / desktop)
const createStyles = ({ isMobile, isTablet, width }) => ({
  //   container: {
  //     display: "flex",
  //     justifyContent: "center",
  //     alignItems: "center",
  //     flexDirection: "column",
  //     fontFamily: "'Arial', sans-serif",
  //     padding: isMobile ? "20px 10px" : isTablet ? "32px 18px" : "40px 20px",
  //     // Add extra top padding for screens that might have overlapping logo
  //     // 1280x720 is common for 150% scaled laptops, also check for similar aspect ratios
  //     paddingTop: width <= 1440 && width > 640
  //       ? "clamp(100px, 12vh, 140px)"
  //       : isMobile
  //         ? "80px"
  //         : isTablet
  //           ? "100px"
  //           : "40px",
  //     backgroundColor: "black",
  //     minHeight: "100vh",
  //     color: gold,
  //   },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily: "'Arial', sans-serif",
    padding: isMobile ? "20px 10px" : isTablet ? "32px 18px" : "40px 20px",
    backgroundColor: "black",
    minHeight: "100vh", // ensures vertical centering
    color: gold,
  },
  cardGrid: {
    display: "grid",
    gap: isMobile ? "16px" : "20px",
    width: "100%",
    gridTemplateColumns: isMobile
      ? "repeat(auto-fill, minmax(240px,1fr))"
      : isTablet
        ? "repeat(auto-fill, minmax(260px,1fr))"
        : "repeat(auto-fill, minmax(280px,1fr))",
    maxWidth: isTablet ? 1100 : 900,
  },
  card: {
    border: `1px solid ${gold}`,
    borderRadius: "10px",
    padding: isMobile
      ? "16px 14px 20px"
      : isTablet
        ? "18px 18px 24px"
        : "20px 20px 26px",
    background: "#0d0d0d",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  cardHeader: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  cardTitle: {
    fontSize: isMobile ? "1.05rem" : isTablet ? "1.1rem" : "1.15rem",
    fontWeight: 600,
    letterSpacing: "0.5px",
  },
  cardPrice: {
    fontSize: isMobile ? "1.25rem" : isTablet ? "1.3rem" : "1.35rem",
    fontWeight: 700,
    marginTop: 2,
  },
  featureList: {
    listStyle: "none",
    padding: 0,
    margin: "4px 0 0",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  featureRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    fontSize: "0.75rem",
    lineHeight: 1.2,
  },
  featureLabel: {
    opacity: 0.85,
    textAlign: "left",
    flex: 1,
  },
  featureValue: {
    fontWeight: 500,
    minWidth: 50,
    textAlign: "right",
  },
  cardActionWrapper: {
    marginTop: 8,
    display: "flex",
    justifyContent: "center",
  },
  tableWrapper: {
    width: "100%",
    maxWidth: isTablet ? "1000px" : "1200px",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    border: `1px solid ${gold}`,
    borderRadius: "8px",
  },
  table: {
    width: "100%",
    minWidth: isMobile ? 650 : isTablet ? 820 : 900, // adjust thresholds
    borderCollapse: "collapse",
  },
  th: {
    padding: isMobile ? "14px 10px" : isTablet ? "16px 14px" : "20px",
    fontSize: isMobile ? "13px" : isTablet ? "14px" : "16px",
    color: gold,
    backgroundColor: "black",
    textAlign: "center",
    border: `1px solid ${gold}`,
    verticalAlign: "top",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  td: {
    padding: isMobile ? "10px 12px" : isTablet ? "12px 14px" : "15px 20px",
    textAlign: "center",
    border: `1px solid ${gold}`,
    backgroundColor: "black",
    color: gold,
    fontSize: isMobile ? "12px" : isTablet ? "13px" : "14px",
    lineHeight: 1.3,
  },
  featureTitle: {
    fontWeight: "bold",
    textAlign: "right",
    paddingRight: isMobile ? "6px" : isTablet ? "8px" : "10px",
    backgroundColor: "black",
    color: gold,
    border: `1px solid ${gold}`,
    position: "sticky",
    left: 0,
    zIndex: 1,
    backgroundClip: "padding-box",
  },
  price: {
    fontSize: isMobile ? "1.4em" : isTablet ? "1.7em" : "2em",
    fontWeight: "bold",
    color: gold,
    margin: isMobile ? "6px 0" : isTablet ? "8px 0" : "10px 0",
    whiteSpace: "nowrap",
  },
  checkmark: {
    color: gold,
    fontWeight: "bold",
  },
  button: {
    padding: isMobile ? "8px 14px" : isTablet ? "9px 18px" : "10px 20px",
    backgroundColor: "transparent",
    color: gold,
    borderRadius: "25px",
    fontSize: isMobile ? "0.75em" : isTablet ? "0.82em" : "0.9em",
    fontWeight: "bold",
    cursor: "pointer",
    border: `1px solid ${gold}`,
    marginTop: isMobile ? "14px" : isTablet ? "16px" : "10px",
    textDecoration: "none",
    transition: "background-color 0.2s, color 0.2s",
  },
  sampleText: {
    fontSize: isMobile ? "0.75em" : isTablet ? "0.82em" : "0.9em",
    color: gold,
    marginTop: "5px",
    lineHeight: 1.3,
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10004,
    padding: "20px",
  },
  modalContent: {
    backgroundColor: "#212121",
    padding: isMobile ? "20px" : isTablet ? "26px" : "30px",
    borderRadius: "10px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
    width: "100%",
    maxWidth: isMobile ? "340px" : isTablet ? "380px" : "400px",
    textAlign: "center",
  },
  modalTitle: {
    fontSize: isMobile ? "1.05em" : isTablet ? "1.15em" : "1.2em",
    fontWeight: "bold",
    marginBottom: "15px",
    color: gold,
  },
  modalMessage: {
    fontSize: isMobile ? "0.9em" : isTablet ? "0.95em" : "1em",
    color: gold,
    marginBottom: "20px",
    lineHeight: "1.4",
  },
  modalButton: {
    padding: isMobile ? "10px 16px" : isTablet ? "10px 18px" : "10px 20px",
    backgroundColor: gold,
    color: "black",
    border: "none",
    borderRadius: "5px",
    fontSize: isMobile ? "0.9em" : isTablet ? "0.95em" : "1em",
    fontWeight: "bold",
    cursor: "pointer",
  },
});

// Hook for viewport width & derived breakpoints
const useViewport = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1920,
  );
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = width < 640; // phones
  const isTablet = width >= 640 && width < 1024; // tablets
  const isLaptop = width >= 1024 && width < 1440; // standard laptops
  const isDesktop = width >= 1440; // large screens

  return { width, isMobile, isTablet, isLaptop, isDesktop };
};

const RewardsPartner = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);
  const [proPlanModalOpen, setProPlanModalOpen] = useState(false);
  const [showGemBonusModal, setShowGemBonusModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currentCoins, setCurrentCoins] = useState(0);
  const [messageModal, setMessageModal] = useState({
    isOpen: false,
    title: "",
    message: "",
  });
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("language") || "en",
  );
  const [referralModalOpen, setReferralModalOpen] = useState(false);
  const [referralCode, setReferralCode] = useState(""); // <-- Add state for referral code
  const [vstatus, setVstatus] = useState(""); // <-- Add vstatus state
  const [refCode, setRefCode] = useState(""); // <-- Add refCode state
  const [vpPaymentType, setVpPaymentType] = useState("monthly"); // Add this state
  const [freePlanLoading, setFreePlanLoading] = useState(false);
  const [referralError, setReferralError] = useState(""); // Add error state
  const [isAffiliate, setIsAffiliate] = useState(false); // true when UPLINE_VP_CODE has data

  useEffect(() => {
    // When refCode is loaded, set it as the default referralCode if not already set
    if (refCode && !referralCode) {
      setReferralCode(refCode);
    }
  }, [refCode]);

  // ✅ Add this new useEffect here
  useEffect(() => {
    // Check if returning from Stripe 3D Secure redirect
    const urlParams = new URLSearchParams(window.location.search);
    const paymentIntent = urlParams.get("payment_intent");
    const paymentIntentClientSecret = urlParams.get(
      "payment_intent_client_secret",
    );

    if (paymentIntent && paymentIntentClientSecret) {
      // User returned from 3D Secure - show success message
      showMessageModal(
        "Payment Processing",
        "Your payment is being verified. Please wait...",
      );

      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setModalOpen(true);
  };

  const openSubscriptionModal = (plan) => {
    console.log("openSubscriptionModal called with plan:", plan);
    setSelectedPlan(plan);
    setSubscriptionModalOpen(true);
    console.log("subscriptionModalOpen should be true now");
  };

  const openProPlanModal = (plan) => {
    console.log("openProPlanModal called with plan:", plan);
    setSelectedPlan(plan);
    setProPlanModalOpen(true);
    console.log("proPlanModalOpen should be true now");
  };

  const closeModal = () => {
    setModalOpen(false);
    setSubscriptionModalOpen(false);
    setProPlanModalOpen(false);
    setSelectedPlan(null);
  };

  const showMessageModal = (title, message) => {
    setMessageModal({ isOpen: true, title, message });
  };

  const closeMessageModal = () => {
    setMessageModal({ isOpen: false, title: "", message: "" });
    window.location.reload();
  };
  const customerID = localStorage.getItem("userID");

  const [activePlans, setActivePlans] = useState([]);

  // Fetch active subscriptions for the user
  useEffect(() => {
    const userID = localStorage.getItem("userID");
    if (userID) {
      fetch(
        `https://xianhefairy.com/LotusFairy_API/Payment/GetStripeSubscriptionByCustomer?custId=${userID}`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (data && data.success && Array.isArray(data.data)) {
            // Normalize SUB_DESC for matching
            const plans = data.data.map((sub) =>
              (sub.SUB_DESC || "").toLowerCase().trim(),
            );
            setActivePlans(plans);
          }
        })
        .catch((err) => console.error("Error fetching subscriptions:", err));
    }
  }, []);

  // Fetch vstatus on mount
  useEffect(() => {
    const userID = localStorage.getItem("userID");
    const userName = localStorage.getItem("username");
    if (userID && userName) {
      fetch("https://xianhefairy.com/LotusFairy_API/api/User/GetProfile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UserName: userName,
          ID: userID,
          UserToken: "",
          Token: {
            AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
          },
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          // Correctly extract VSTATUS and REF_CODE from Profiles[0]
          if (
            data &&
            Array.isArray(data.Profiles) &&
            data.Profiles.length > 0
          ) {
            const prof = data.Profiles[0];
            const profRefCode = prof.REF_CODE && String(prof.REF_CODE).trim();
            const vvpCode = prof.VVP_CODE && String(prof.VVP_CODE).trim();
            const vpCode = prof.VP_CODE && String(prof.VP_CODE).trim();
            // Prefer REF_CODE first, then VVP_CODE, then VP_CODE
            const partnerReferralCode = profRefCode || vvpCode || vpCode || "";
            setVstatus(prof.VSTATUS?.toLowerCase() || "");
            setRefCode(partnerReferralCode);
            const uplineVal = String(prof.VSTATUS ?? "").trim();
            setIsAffiliate(
              uplineVal !== "" && uplineVal.toLowerCase() !== "null",
            );

            // Persist useful user fields to localStorage so other components can read them
            try {
              if (prof.FullName) localStorage.setItem("name", prof.FullName);
              if (prof.Email) localStorage.setItem("email", prof.Email);
              if (prof.UserName)
                localStorage.setItem("username", prof.UserName);
              if (prof.ID !== undefined && prof.ID !== null)
                localStorage.setItem("userID", String(prof.ID));
              if (prof.Coins !== undefined && prof.Coins !== null)
                localStorage.setItem("coins", String(prof.Coins));
              if (prof.REF_CODE)
                localStorage.setItem("REF_CODE", prof.REF_CODE);
              if (prof.VVP_CODE)
                localStorage.setItem("VVP_CODE", prof.VVP_CODE);
              if (prof.VP_CODE) localStorage.setItem("VP_CODE", prof.VP_CODE);
            } catch (e) {
              console.warn("Unable to write profile to localStorage:", e);
            }
          }
        })
        .catch((err) => {
          console.error("Error fetching vstatus/ref_code:", err);
        });
    }
  }, []);

  const updateMembership = async (customerID, planType, referralCode = "") => {
    const token = "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp";
    const currentDate = new Date().toISOString();

    // Check if plan is any Virtual Partner variant
    const isVirtualPartnerPlan =
      planType === "Affiliate Partner" ||
      planType === "Virtual Partner Soft Launch";

    const payload = {
      uid: "",
      customerID: customerID,
      membershipPro: planType === "Pro Plan" ? currentDate : "",
      virtualPartner: isVirtualPartnerPlan ? currentDate : "",
      createdBy: "admin",
      updatedBy: "admin",
      referralCode: isVirtualPartnerPlan ? referralCode : "", // Pass referralCode for any VP plan
    };

    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/booking/UpdateMembership?token=${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      // Try to read and parse the response body for better diagnostics
      let respText = null;
      try {
        respText = await response.text();
      } catch (e) {
        console.error(
          "Unable to read UpdateMembership response body:",
          e.message,
        );
      }

      if (response.ok) {
        // Log parsed JSON when possible, otherwise log raw text
        try {
          const parsed = respText ? JSON.parse(respText) : null;
          console.log("Membership updated successfully:", parsed ?? respText);
        } catch (e) {
          console.log("Membership updated successfully (text):", respText);
        }
        console.log("UpdateMembership payload:", payload);
        return true;
      } else {
        try {
          const parsed = respText ? JSON.parse(respText) : null;
          console.error(
            "Failed to update membership:",
            response.status,
            parsed ?? respText,
          );
        } catch (e) {
          console.error(
            "Failed to update membership:",
            response.status,
            respText,
          );
        }
        return false;
      }
    } catch (error) {
      console.error("Error updating membership:", error);
      return false;
    }
  };

  // Create a Simple Account on the Aleta affiliate system after a successful Affiliate Partner payment
  // const createSimpleAccount = async (custId) => {
  //   const payload = {
  //     CustId: Number(custId) || 0,
  //     IdValue: String(custId),
  //   };

  //   try {
  //     console.log("Creating SimpleAccount with payload:", payload);
  //     const res = await fetch("https://XianheAletaApi/api/pa/SimpleAccount", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const respText = await res.text();
  //     if (!res.ok) {
  //       console.error("SimpleAccount creation failed:", res.status, respText);
  //       return false;
  //     }

  //     console.log("SimpleAccount created successfully:", respText);
  //     return true;
  //   } catch (error) {
  //     console.error("Error creating SimpleAccount:", error);
  //     return false;
  //   }
  // };

  // Create subscription for Free Plan using the provided API
  const createFreePlanSubscription = async () => {
    setFreePlanLoading(true);
    // Try to derive email and customerName from localStorage; fall back to reasonable defaults
    const email =
      localStorage.getItem("email") ||
      (localStorage.getItem("username")
        ? `${localStorage.getItem("username")}@example.com`
        : "alphajoy.novillas@gmail.com");
    const customerName = localStorage.getItem("username") || "alpha";
    // For free plan we don't auto-attach a payment method here. If the backend
    // needs a PM, it should be provided after the user enters card details.
    const payload = {
      email,
      customerName,
      freePlanPriceId: FREE_PLAN_PRICE_ID,
    };

    try {
      console.log("Creating free plan subscription with payload:", payload);
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/Payment/CreateFreePlanSubscription",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (e) {
        data = text;
      }

      if (res.ok) {
        console.log("CreateFreePlanSubscription success:", data ?? text);
        // Update membership locally/server-side if needed
        const userId = localStorage.getItem("userID") || "";
        if (userId) {
          try {
            await updateMembership(userId, "Free Plan");
          } catch (e) {
            console.warn("updateMembership failed after free plan creation", e);
          }
        }

        showMessageModal(
          "Success",
          "Free plan subscription created successfully.",
        );
        // refresh coins/profile as needed
        fetchData();
        setFreePlanLoading(false);
        return true;
      } else {
        console.error("CreateFreePlanSubscription failed:", res.status, text);
        showMessageModal(
          "Error",
          `Failed to create free plan subscription: ${text || res.statusText}`,
        );
        setFreePlanLoading(false);
        return false;
      }
    } catch (err) {
      console.error("Error creating free plan subscription:", err);
      showMessageModal(
        "Error",
        "Network error creating free plan subscription. Please try again.",
      );
      setFreePlanLoading(false);
      return false;
    }
  };

  // Create subscription for Pro Plan (monthly)
  const createProPlanMonthlySubscription = async () => {
    // Similar pattern to createFreePlanSubscription but uses the Pro plan endpoint
    setFreePlanLoading(true);
    const email =
      localStorage.getItem("email") ||
      (localStorage.getItem("username")
        ? `${localStorage.getItem("username")}@example.com`
        : "");
    const customerName =
      localStorage.getItem("username") || localStorage.getItem("name") || "";

    const payload = {
      Email: email,
      CustomerName: customerName || "Unknown",
      MonthlyProPlanPriceId: "price_1SQjhHH4SEOW1T3dFABVcmTL",
    };

    try {
      console.log(
        "Creating Pro Plan monthly subscription with payload:",
        payload,
      );
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/Payment/CreateProPlanMonthlySubscription",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (e) {
        data = text;
      }

      if (res.ok) {
        console.log("CreateProPlanMonthlySubscription success:", data ?? text);
        const userId = localStorage.getItem("userID") || "";
        if (userId) {
          try {
            await updateMembership(userId, "Pro Plan");
          } catch (e) {
            console.warn("updateMembership failed after Pro plan creation", e);
          }
        }

        showMessageModal(
          "Success",
          "Pro Plan subscription created successfully.",
        );
        fetchData();
        setFreePlanLoading(false);
        return true;
      } else {
        console.error(
          "CreateProPlanMonthlySubscription failed:",
          res.status,
          text,
        );
        showMessageModal(
          "Error",
          `Failed to create Pro Plan subscription: ${text || res.statusText}`,
        );
        setFreePlanLoading(false);
        return false;
      }
    } catch (err) {
      console.error("Error creating Pro Plan subscription:", err);
      showMessageModal(
        "Error",
        "Network error creating Pro Plan subscription. Please try again.",
      );
      setFreePlanLoading(false);
      return false;
    }
  };

  // Helper to post purchase coin record using new API shape
  const postPurchaseCoin = async (customerID, amount, pid = 0) => {
    const payload = {
      prefix: "PS",
      Items: [
        {
          CustomerId: Number(customerID) || 0,
          pid: pid,
          Quantity: 1,
          Amount: amount,
        },
      ],
    };

    try {
      console.log("Posting PostPurchaseCoin payload:", payload);
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/member/PostPurchaseCoin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      // Read body text to surface server error details
      const respText = await res.text();
      console.log(
        "PostPurchaseCoin response status:",
        res.status,
        res.statusText,
      );
      try {
        const parsed = respText ? JSON.parse(respText) : null;
        console.log("PostPurchaseCoin response body (json):", parsed);
      } catch (e) {
        console.log("PostPurchaseCoin response body (text):", respText);
      }

      if (!res.ok) {
        console.error(
          "PostPurchaseCoin failed (status",
          res.status,
          "):",
          respText,
        );
        return false;
      }

      // success
      try {
        const data = respText ? JSON.parse(respText) : null;
        console.log("PostPurchaseCoin response:", data);
      } catch (e) {
        console.log("PostPurchaseCoin response (text):", respText);
      }
      return true;
    } catch (error) {
      console.error("Error in PostPurchaseCoin:", error);
      return false;
    }
  };

  // Minimal helper to calculate total cost based on selected plan
  const calculateTotalCost = () => {
    if (selectedPlan === "Pro Plan") return 399;
    if (selectedPlan === "Affiliate Partner") return 499;
    // if (selectedPlan === "Pro Plan") return 699;
    // if (selectedPlan === "Virtual Partner") return 699;
    return 0;
  };

  // Fetch current coins for this user and update state
  const fetchData = async () => {
    try {
      const userID = localStorage.getItem("userID");
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      if (Array.isArray(data) && data.length > 0) {
        setCurrentCoins(data[0].COINS);
      } else if (data && data.COINS !== undefined) {
        setCurrentCoins(data.COINS);
      } else {
        setCurrentCoins(0);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setCurrentCoins(0);
    }
  };

  const handlePurchase = async () => {
    const cost = calculateTotalCost();
    const today = new Date().toISOString().split("T")[0];
    const userID = localStorage.getItem("userID");

    // determine pid mapping: Pro Plan -> 101, Affiliate Partner -> 102
    const planPid =
      selectedPlan === "Pro Plan"
        ? 101
        : selectedPlan === "Affiliate Partner"
          ? 102
          : 0;

    // Build payload in the new required shape
    const purchasePayload = {
      prefix: "PS",
      Items: [
        {
          CustomerId: Number(userID) || 0,
          pid: planPid,
          Quantity: 1,
          Amount: cost,
        },
      ],
    };
    try {
      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/member/PostPurchaseCoin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(purchasePayload),
        },
      );

      const data = await response.json();

      if (data) {
        console.log(`Purchase successful`);
        console.log(data);
        fetchData();
      } else {
        console.log("Did not work");
      }
    } catch (error) {
      console.log(`Error: ${error.message}`);
    }
    // Assume transaction logic here
    // setTransactionSuccessful(true);
    console.log("transaction complete");
  };

  const handlePaymentSuccess = async (result) => {
    // result can be either a legacy customerID string, or an object returned by CheckoutForm
    // { stripeCustomerId, paymentMethodId, localCustomerId }
    let localCustomerId = null;
    try {
      if (result && typeof result === "object") {
        // New flow: use payment method from Stripe
        const {
          stripeCustomerId,
          paymentMethodId,
          localCustomerId: providedLocalId,
        } = result;
        localCustomerId = providedLocalId || localStorage.getItem("userID");

        console.log(
          "Payment succeeded with Stripe customer:",
          stripeCustomerId,
        );
        console.log("Payment method ID:", paymentMethodId);
        // Note: For regular payments, subscription creation is handled separately
      } else {
        // legacy: result is local customerID
        localCustomerId = result || localStorage.getItem("userID");
      }

      // Update membership and post purchase coin record as before
      const success = await updateMembership(
        localCustomerId,
        selectedPlan,
        referralCode,
      );
      if (success) {
        showMessageModal(
          "Success!",
          "Payment successful and membership updated!",
        );

        // post purchase coin record (amount depends on plan)
        const amount = selectedPlan === "Pro Plan" ? 399 : 99; // cents or minor units as needed
        // const amount = selectedPlan === "Pro Plan" ? 699 : 699; // cents or minor units as needed
        const pid = (() => {
          const plan = planData.find((p) => p.name === selectedPlan);
          return plan ? plan.pid || 0 : 0;
        })();

        // postPurchaseCoin(localCustomerId, amount, pid)
        //   .then(() => console.log("Purchase coin posted"))
        //   .catch((e) => console.error(e));

        closeModal();
      } else {
        showMessageModal(
          "Warning",
          "Payment successful but failed to update membership. Please contact support.",
        );
      }
    } catch (err) {
      console.error("handlePaymentSuccess error:", err);
      showMessageModal("Error", "An unexpected error occurred after payment.");
    }
  };

  const handleSubscriptionPaymentSuccess = async (result) => {
    // result contains { paymentIntent, subscription, saveStatus, saveError }
    // where subscription has { id, clientSecret, status }
    let localCustomerId = localStorage.getItem("userID");

    try {
      const { paymentIntent, subscription, saveStatus, saveError } = result;

      console.log("Subscription payment success:", {
        oneTimePayment: paymentIntent,
        subscription: subscription,
        saveStatus,
        saveError,
      });

      // Update membership with subscription info
      const success = await updateMembership(
        localCustomerId,
        selectedPlan,
        referralCode,
      );

      // Close the Stripe modal first so the message modal is on top
      closeModal();

      const piStatus = paymentIntent && paymentIntent.status;
      const paymentOk = piStatus === "succeeded" || piStatus === "processing";

      if (!paymentOk) {
        showMessageModal(
          "Payment Issue",
          `Your payment status is "${piStatus || "unknown"}". If you were charged, please contact support before retrying.`,
        );
        return;
      }

      // Payment succeeded for the Affiliate Partner plan — create the Aleta SimpleAccount
      try {
        // await createSimpleAccount(localCustomerId);
      } catch (e) {
        // console.warn("createSimpleAccount failed after affiliate payment", e);
      }

      // Payment succeeded — now report on backend save + membership state
      if (saveStatus === "success" && success) {
        showMessageModal(
          "Welcome, Affiliate Partner!",
          "🎉 Payment successful! You are officially an Affiliate Partner. Press OK to refresh and access your benefits.",
        );
      } else if (saveStatus === "success" && !success) {
        showMessageModal(
          "Almost There",
          "Payment received and subscription saved, but we couldn't update your membership status. Please contact support with your payment reference so we can activate your Affiliate Partner benefits.",
        );
      } else if (saveStatus === "failed") {
        showMessageModal(
          "Payment Received — Action Needed",
          `Your payment was successful, but we were unable to save your subscription to our records${
            saveError ? ` (${saveError})` : ""
          }. Please DO NOT pay again. Contact support with your email and we will activate your Affiliate Partner account.`,
        );
      } else {
        // saveStatus === 'skipped' or undefined
        showMessageModal(
          "Payment Processing",
          "Your payment is being processed. Your Affiliate Partner status will be activated once payment is fully confirmed. You will receive an email update.",
        );
      }
    } catch (err) {
      console.error("handleSubscriptionPaymentSuccess error:", err);
      showMessageModal(
        "Error",
        "An unexpected error occurred after subscription payment. If you were charged, please contact support before retrying.",
      );
    }
  };

  const handleProPlanPaymentSuccess = async (result) => {
    // result contains { paymentIntent, subscription }
    let localCustomerId = localStorage.getItem("userID");

    try {
      const { paymentIntent, subscription } = result;

      console.log("Pro Plan payment success:", {
        paymentIntent,
        subscription: subscription,
      });

      // Update membership with subscription info
      const success = await updateMembership(
        localCustomerId,
        selectedPlan,
        referralCode,
      );

      if (success) {
        showMessageModal(
          "Success!",
          `Payment successful! Subscription: ${subscription.status} (ID: ${subscription.id})`,
        );

        closeModal();
        window.location.reload();
      } else {
        showMessageModal(
          "Warning",
          "Payment successful but failed to update membership. Please contact support.",
        );
      }
    } catch (err) {
      console.error("handleProPlanPaymentSuccess error:", err);
      showMessageModal(
        "Error",
        "An unexpected error occurred after Pro Plan payment.",
      );
    }
  };

  const { width, isMobile, isTablet } = useViewport();
  const styles = createStyles({ isMobile, isTablet, width }); // Pass width to styles

  // Data model for features (to avoid duplication in mobile card view)
  const planData = [
    // {
    //   name: "Free Plan",
    //   price: "Plan",
    //   badge: "Always Free",
    //   tagline: "All the basic exploring to enhance your life.",
    //   attendBasicCourse: "N.A.",
    //   aiGeneratedLifeChart: true,
    //   y2025LifeChart: false,
    //   lifeLabAccess: "Limited",
    //   discountRate: "5%",
    //   commissionReferral: false,
    //   cta: "Get Started for Free",
    //   isPaid: false,
    // },
    // {
    //   name: "Pro Plan",
    //   price: "$3.99 / mo",
    //   badge: "$3.99 / mo",
    //   tagline: "Everything you need for deeper understanding.",
    //   attendBasicCourse: "N.A.",
    //   aiGeneratedLifeChart: true,
    //   y2025LifeChart: true,
    //   lifeLabAccess: "Full Access",
    //   discountRate: "10%",
    //   commissionReferral: false,
    //   cta: "Get Started",
    //   isPaid: true,
    //   // TODO: replace with your actual Stripe Price ID for the monthly plan
    //   priceId: "price_pro_monthly",
    //   // local pid used by PostPurchaseCoin
    //   pid: 101,
    //   highlight: true,
    // },
    // {
    //   name: "Virtual Partner",
    //   price: "$4.99 / mo or $399 one-time",
    //   badge: "$4.99 / mo or $399 one-time",
    //   tagline: "Perfect for committed individuals & voices.",
    //   attendBasicCourse: "Required",
    //   aiGeneratedLifeChart: true,
    //   y2025LifeChart: true,
    //   lifeLabAccess: "Full Access",
    //   discountRate: "10%",
    //   commissionReferral: true,
    //   cta: "Get Started", // <-- Changed from "Coming Soon"
    //   isPaid: true,
    //   priceId: "price_virtualpartner_monthly",
    //   pid: 102,
    //   highlight: true,
    // },
    {
      id: "Affiliate Partner", // <-- Add this unique ID
      name: t("affiliatePartnerPlan.title"),
      price: t("affiliatePartnerPlan.price"),
      badge: t("affiliatePartnerPlan.price"),
      tagline: t("affiliatePartnerPlan.tagline"),
      attendBasicCourse: "Required",
      aiGeneratedLifeChart: true,
      y2025LifeChart: true,
      lifeLabAccess: "Full Access",
      discountRate: "10%",
      commissionReferral: true,
      cta: t("affiliatePartnerPlan.getStarted"), // <-- Changed from "Coming Soon"
      isPaid: true,
      priceId: "price_virtualpartner_monthly",
      pid: 102,
      highlight: true,
      features: [
        "✓ " + t("affiliatePartnerPlan.feature1"),
        "✓ " + t("affiliatePartnerPlan.feature2"),
        "✓ " + t("affiliatePartnerPlan.feature3"),
        "✓ " + t("affiliatePartnerPlan.feature4"),
        "✓ " + t("affiliatePartnerPlan.feature5"),
      ],
    },
  ];

  const verifyReferralCode = async (refCode) => {
    if (!refCode) return false;
    try {
      const resp = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/user/IsRefCodeExist?refCode=${encodeURIComponent(
          refCode,
        )}`,
      );
      const data = await resp.json();
      return data.successful === true;
    } catch (e) {
      console.error("Referral code verification failed:", e);
      return false;
    }
  };
  // Benefit cards for the "Enjoy exclusive in-app benefits" section
  const benefitCards = [
    {
      img: gems,
      title: t('affiliatePartnerPlan.benefitCardTitle1'),
      desc: t('affiliatePartnerPlan.benefitCardDesc1'),
    },
    {
      img: fulllife,
      title: t('affiliatePartnerPlan.benefitCardTitle2'),
      desc: t('affiliatePartnerPlan.benefitCardDesc2'),
    },
    {
      img: unlidraw,
      title: t('affiliatePartnerPlan.benefitCardTitle3'),
      desc: t('affiliatePartnerPlan.benefitCardDesc3'),
    },
    {
      img: selfmastery,
      title: t('affiliatePartnerPlan.benefitCardTitle4'),
      desc: t('affiliatePartnerPlan.benefitCardDesc4'),
    },
    {
      img: blessedluck,
      title: t('affiliatePartnerPlan.benefitCardTitle5'),
      desc: t('affiliatePartnerPlan.benefitCardDesc5'),
    },
    {
      img: guidedmeditation,
      title: t('affiliatePartnerPlan.benefitCardTitle6'),
      desc: t('affiliatePartnerPlan.benefitCardDesc6'),
    },
    {
      img: personalizedplan,
      title: t('affiliatePartnerPlan.benefitCardTitle7'),
      desc: t('affiliatePartnerPlan.benefitCardDesc7'),
    },
    {
      img: discountedgem,
      title: t('affiliatePartnerPlan.benefitCardTitle8'),
      desc: t('affiliatePartnerPlan.benefitCardDesc8'),
      desc2: t('affiliatePartnerPlan.benefitCardDesc8b'),
      onClick: () => setShowGemBonusModal(true),
    },
  ];

  const isExistingIcOrAp = vstatus === "vvp" || vstatus === "vp";

  return (
    <div
      style={{
        // backgroundColor: "#07071a",
        color: gold,
        fontFamily: "'Arial', sans-serif",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: isMobile ? "60px 20px 40px" : "80px 40px 50px",
          maxWidth: 750,
          margin: "0 auto",
        }}
      >
        <h1
          style={{
            color: gold,
            fontSize: isMobile ? "1.8rem" : isTablet ? "2rem" : "2.4rem",
            fontWeight: 700,
            marginBottom: 20,
            letterSpacing: 0.5,
            fontFamily: "Playfair Display, serif",
          }}
        >
          {t('affiliatePartnerPlan.pageTitle')}
        </h1>
        <p
          style={{
            fontSize: isMobile ? "0.88rem" : "0.97rem",
            lineHeight: 1.8,
            color: "white",
            maxWidth: 660,
            margin: "0 auto",
          }}
          dangerouslySetInnerHTML={{ __html: t('affiliatePartnerPlan.heroText') }}
        />
        <img
          src={image}
          alt="XianHe Affiliate"
          style={{
            marginTop: "10px",
            maxWidth: "600px",
            width: "100%",
            height: "40px",
            borderRadius: "12px",
            opacity: 0.1,
            color: "#3e363d",
          }}
        />
      </div>

      {/* Why Join Section */}
      <div
        style={{
          textAlign: "center",
          padding: isMobile ? "30px 20px" : "40px 20px",
          maxWidth: 700,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "8px",
            position: "relative",
          }}
        >
          <div
            style={{
              height: "120px",
              overflow: "hidden",
              marginBottom: "-35px",
              opacity: 0.1,
              zIndex: 0,
            }}
          >
            <img
              src={crown}
              alt="Crown"
              style={{ width: "200px", objectFit: "contain", display: "block" }}
            />
          </div>
          <h2
            style={{
              color: gold,
              fontSize: isMobile ? "1.4rem" : isTablet ? "1.6rem" : "1.9rem",
              fontWeight: 700,
              marginBottom: 16,
              position: "relative",
              zIndex: 1,
              margin: 0,
              fontFamily: "Playfair Display, serif",
            }}
          >
            {t('affiliatePartnerPlan.whyJoinTitle')}
          </h2>
        </div>
        <p
          style={{
            fontSize: isMobile ? "0.88rem" : "0.95rem",
            lineHeight: 1.8,
            color: "white",
          }}
        >
          {t('affiliatePartnerPlan.whyJoinText')}
        </p>
      </div>

      {/* Enjoy exclusive in-app benefits */}
      <div
        style={{
          padding: isMobile ? "20px 16px 50px" : "20px 40px 60px",
          maxWidth: 960,
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: gold,
            fontSize: isMobile ? "1.2rem" : isTablet ? "1.4rem" : "1.6rem",
            fontWeight: 700,
            marginBottom: isMobile ? 20 : 30,
          }}
        >
          {t('affiliatePartnerPlan.benefitsTitle')}
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "repeat(2, 1fr)"
              : isTablet
                ? "repeat(2, 1fr)"
                : "repeat(4, 1fr)",
            gap: isMobile ? 14 : 20,
          }}
        >
          {benefitCards.map((benefit, idx) => (
            <div
              key={idx}
              onClick={benefit.onClick}
              style={{
                border: `1px solid rgba(223,189,105,0.35)`,
                borderRadius: 12,
                padding: isMobile ? "16px 12px" : "24px 16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                background: "#0A031E",
                cursor: benefit.onClick ? "pointer" : "default",
              }}
            >
              <img
                src={benefit.img}
                alt={benefit.title}
                style={{
                  width: isMobile ? 60 : 80,
                  height: isMobile ? 60 : 80,
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: 12,
                }}
              />
              <div
                style={{
                  fontWeight: 600,
                  fontSize: isMobile ? "0.8rem" : "0.88rem",
                  marginBottom: 8,
                  color: gold,
                  lineHeight: 1.3,
                  fontFamily: "Playfair Display, serif",
                }}
              >
                {benefit.title}
              </div>
              <div
                style={{
                  fontSize: isMobile ? "0.7rem" : "0.78rem",
                  color: "white",
                  lineHeight: 1.5,
                }}
              >
                {benefit.desc}
              </div>
              {benefit.desc2 && (
                <div
                  style={{
                    fontSize: isMobile ? "0.7rem" : "0.78rem",
                    color: "white",
                    lineHeight: 1.5,
                    marginTop: 6,
                  }}
                >
                  {benefit.desc2}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div
        style={{
          textAlign: "center",
          padding: isMobile ? "30px 20px 70px" : "40px 20px 90px",
          maxWidth: 700,
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            color: gold,
            fontSize: isMobile ? "1.4rem" : isTablet ? "1.6rem" : "1.9rem",
            fontWeight: 700,
            marginBottom: 16,
            fontFamily: "Playfair Display, serif",
          }}
        >
          {t('affiliatePartnerPlan.becomeAffiliateTitle')}
        </h2>
        <p
          style={{
            fontSize: isMobile ? "0.88rem" : "0.95rem",
            lineHeight: 1.8,
            color: "#FFF2D2",
            marginBottom: 28,
          }}
        >
          {t('affiliatePartnerPlan.becomeAffiliateText')}
        </p>
        <input
          type="text"
          placeholder={
            t("affiliatePartnerPlan.enterReferralCode") ||
            "Enter referral code (optional)"
          }
          value={referralCode || refCode || ""}
          onChange={(e) => {
            // only allow editing when the user isn't already an IC or AP
            if (!isExistingIcOrAp) {
              setReferralCode(e.target.value);
              setReferralError("");
            }
          }}
          disabled={isExistingIcOrAp}
          style={{
            display: "block",
            width: "100%",
            maxWidth: 320,
            margin: "0 auto 14px",
            padding: "10px 14px",
            borderRadius: "8px",
            border: `1px solid ${gold}`,
            background: isExistingIcOrAp ? "#2b2b2b" : "#181818",
            color: isExistingIcOrAp ? "#A0A0A0" : gold,
            fontSize: "0.9rem",
            textAlign: "center",
            boxSizing: "border-box",
            cursor: isExistingIcOrAp ? "not-allowed" : "text",
            opacity: isExistingIcOrAp ? 0.8 : 1,
          }}
        />
        {referralError && (
          <div style={{ color: "red", fontSize: "0.85rem", marginBottom: 10 }}>
            {referralError}
          </div>
        )}
        <button
          style={{
            padding: isMobile ? "11px 32px" : "12px 44px",
            backgroundColor: "#DEAF77",
            color: "#1B0E3C",
            border: `1px solid ${gold}`,
            borderRadius: "25px",
            fontSize: isMobile ? "0.9rem" : "1rem",
            fontWeight: 700,
            cursor: "pointer",
            letterSpacing: 0.5,
            transition: "background-color 0.2s, color 0.2s",
          }}
          onClick={async () => {
            if (!customerID) {
              showMessageModal(
                t('affiliatePartnerPlan.signInRequiredTitle'),
                t('affiliatePartnerPlan.signInRequiredMessage')
              );
              return;
            }
            if (isAffiliate) {
              showMessageModal(
                t('affiliatePartnerPlan.alreadyAffiliateTitle'),
                t('affiliatePartnerPlan.alreadyAffiliateMessage')
              );
              return;
            }
            const plan = planData[0];
            const codeToCheck = referralCode || refCode || "";
            if (codeToCheck) {
              const valid = await verifyReferralCode(codeToCheck);
              if (!valid) {
                setReferralError(
                  t('affiliatePartnerPlan.invalidReferralError')
                );
                return;
              }
              setReferralCode(codeToCheck);
              setReferralError("");
            }
            openSubscriptionModal(plan.id);
          }}
        >
          {t('affiliatePartnerPlan.signupNow')}
        </button>
      </div>

      {/* Legacy plan map - kept hidden for subscription logic compatibility */}
      <div style={{ display: "none" }}>
        {planData.map((plan) => {
          const highlight = plan.highlight;
          // const isVirtualPartner = plan.name === "Virtual Partner";
          const isSoftLaunchVP = plan.id === "Affiliate Partner";
          const isFreePlan = plan.name === "Free Plan";
          // const hideReferral = isVirtualPartner && (vstatus === "vp" || vstatus === "vvp");
          const normalizedPlanName = plan.id.toLowerCase();
          // console.log(
          //   "activePlans:",
          //   activePlans,
          //   "checking:",
          //   normalizedPlanName,
          // );
          const isRegistered = activePlans.includes(normalizedPlanName);
          return (
            <div
              key={plan.name}
              style={{
                position: "relative",
                border: `1px solid ${gold}`,
                borderRadius: 14,
                padding: isMobile ? "20px 18px 24px" : "26px 22px 32px",
                background: isRegistered
                  ? "#444"
                  : highlight
                    ? "linear-gradient(145deg,#0d0d0d 0%, #151515 60%, #0d0d0d 100%)"
                    : "#0d0d0d",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                boxShadow: highlight
                  ? `0 0 0 1px ${gold}, 0 4px 18px -6px rgba(223,189,105,0.25)`
                  : "0 2px 10px -4px rgba(0,0,0,0.6)",
                minHeight: 670,
                height: "100%",
                opacity: isRegistered ? 0.5 : 1,
                pointerEvents: isRegistered ? "none" : "auto",
                width: isMobile ? "100%" : "600px", // <-- Set fixed width for each card
                margin: "0 0",
              }}
              aria-labelledby={`${plan.name.replace(/\s/g, "")}-title`}
            >
              {/* Top badge */}
              {plan.badge && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: -1,
                    transform: "translateY(-50%)",
                    background: "black",
                    border: `1px solid ${gold}`,
                    borderRadius: "6px 6px 6px 0",
                    padding: "4px 10px 6px",
                    fontSize: 11,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                  }}
                >
                  {plan.badge}
                </div>
              )}

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <h3
                  id={`${plan.name.replace(/\s/g, "")}-title`}
                  style={{
                    margin: 0,
                    fontSize: isMobile
                      ? "1.3rem"
                      : highlight
                        ? "1.55rem"
                        : "1.45rem",
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textAlign: "left",
                    color: gold,
                  }}
                >
                  {plan.name}
                </h3>
                <div
                  style={{
                    fontSize: isMobile ? "0.75rem" : "0.78rem",
                    opacity: 0.85,
                    lineHeight: 1.3,
                    minHeight: 32,
                  }}
                >
                  {plan.tagline}
                </div>
                <div
                  style={{
                    fontSize: isMobile ? "1.4rem" : "1.65rem",
                    fontWeight: 800,
                    marginTop: 4,
                    color: gold,
                  }}
                >
                  {isSoftLaunchVP ? (
                    <>
                      <span>{plan.price}</span>
                      {/* <span style={{ margin: "0 4px" }}>&</span>
                      <span>
                        US$ 4.99{" "}
                        <span style={{ fontSize: 13 }}>/ mo (starts June)</span>
                      </span> */}
                    </>
                  ) : (
                    plan.price
                  )}
                </div>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  margin: isMobile ? "14px 0 0" : "20px 0 0",
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  fontSize: isMobile ? 12 : 13,
                }}
              >
                {plan.features ? (
                  plan.features.map((feature, idx) => (
                    <li key={idx} dangerouslySetInnerHTML={{ __html: feature }} />
                  ))
                ) : (
                  <>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>
                        Life Forecast insights—your daily, monthly and yearly
                        energies revealed for better decisions in wealth,
                        career, relationships, health and wisdom.{" "}
                      </span>
                      <span>
                        {plan.attendBasicCourse ? (
                          <strong style={{ color: gold }}>✓</strong>
                        ) : (
                          "✕"
                        )}
                      </span>
                    </li>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>
                        Two daily The Wheel draws offering higher guidance for
                        your Questions
                      </span>
                      <span>
                        {plan.aiGeneratedLifeChart ? (
                          <strong style={{ color: gold }}>✓</strong>
                        ) : (
                          "✕"
                        )}
                      </span>
                    </li>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>
                        Exclusive Self-Mastery courses by Master Siew Li to
                        elevate your intuition, energy and personal power
                      </span>
                      <span>
                        {plan.y2025LifeChart ? (
                          <strong style={{ color: gold }}>✓</strong>
                        ) : (
                          "✕"
                        )}
                      </span>
                    </li>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>
                        Exclusive Self-Mastery courses from Master Siew Li to
                        elevate intuition and personal energy
                      </span>
                      <span>
                        {plan.lifeLabAccess ? (
                          <strong style={{ color: gold }}>✓</strong>
                        ) : (
                          "✕"
                        )}
                      </span>
                    </li>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>
                        A blessed Good Luck Amulet carrying Master Siew Li’s
                        esoteric protection
                      </span>
                      <span>
                        {plan.discountRate ? (
                          <strong style={{ color: gold }}>✓</strong>
                        ) : (
                          "✕"
                        )}
                      </span>
                    </li>
                    <li
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 8,
                      }}
                    >
                      <span>
                        Two 1-minute Guided Meditations (launching June 2026) to
                        refresh and rebalance your energy.
                      </span>
                      <span>
                        {plan.commissionReferral ? (
                          <strong style={{ color: gold }}>✓</strong>
                        ) : (
                          "✕"
                        )}
                      </span>
                    </li>
                  </>
                )}
              </ul>

              <div
                style={{
                  marginTop: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                {/* Referral code input and instructions always shown for Virtual Partner */}
                {/* {isVirtualPartner &&  (
                  <>
                    <input
                      type="text"
                      placeholder="Enter referral code"
                      value={referralCode}
                      onChange={e => setReferralCode(e.target.value)}
                      style={{
                        width: "100%",
                        padding: isMobile ? "7px 10px" : "9px 12px",
                        borderRadius: "6px",
                        border: `1px solid ${gold}`,
                        background: "#181818",
                        color: gold,
                        fontSize: isMobile ? 12 : 14,
                        marginTop: 2,
                        marginBottom: 2,
                      }}
                    />
                    <div
                      style={{
                        color: gold,
                        fontSize: isMobile ? 11 : 13,
                        textAlign: "left",
                        cursor: "pointer",
                        textDecoration: "underline",
                        opacity: 0.85,
                        width: "75%",
                      }}
                      onClick={() => setReferralModalOpen(true)}
                    >
                      How to avail referral code? <span style={{ color: gold, textDecoration: "underline" }}>Click Here</span>
                    </div>
                  </>
                )} */}
                {isSoftLaunchVP && (
                  <>
                    <input
                      type="text"
                      placeholder={t("affiliatePartnerPlan.enterReferralCode")}
                      value={referralCode}
                      onChange={(e) => setReferralCode(e.target.value)}
                      style={{
                        width: "100%",
                        padding: isMobile ? "7px 10px" : "9px 12px",
                        borderRadius: "6px",
                        border: `1px solid ${gold}`,
                        background: "#181818",
                        color: gold,
                        fontSize: isMobile ? 12 : 14,
                        marginTop: 2,
                        marginBottom: 2,
                      }}
                    />
                    <div
                      style={{
                        color: gold,
                        fontSize: isMobile ? 11 : 13,
                        textAlign: "left",
                        cursor: "pointer",
                        textDecoration: "underline",
                        opacity: 0.85,
                        width: "75%",
                      }}
                      onClick={() => setReferralModalOpen(true)}
                    >
                      {t("affiliatePartnerPlan.howToAvailReferralCode")}
                    </div>
                  </>
                )}
                {/* Get Started button always shown for all plans */}
                <button
                  style={{
                    ...styles.button,
                    width: "100%",
                    background: highlight
                      ? gold
                      : plan.isPaid
                        ? "transparent"
                        : "transparent",
                    color: highlight ? "black" : plan.isPaid ? gold : gold,
                    opacity: isRegistered ? 0.6 : 1,
                    cursor: isRegistered ? "not-allowed" : "pointer",
                  }}
                  onClick={async () => {
                    if (isRegistered) return;
                    if (isFreePlan) {
                      await createFreePlanSubscription();
                    }
                    // else if (isSoftLaunchVP) {
                    //   // Verify referral code before proceeding
                    //   const codeToCheck = referralCode || refCode || "";
                    //   if (!codeToCheck) {
                    //     setReferralError("Please enter a referral code.");
                    //     return;
                    //   }
                    //   setReferralError("");
                    //   const valid = await verifyReferralCode(codeToCheck);
                    //   if (valid) {
                    //     setReferralCode(codeToCheck);
                    //     openSubscriptionModal(plan.name);
                    //   } else {
                    //     setReferralError(
                    //       "Invalid referral code. Please check and try again."
                    //     );
                    //   }
                    // }
                    else if (isSoftLaunchVP) {
                      // Referral code is optional
                      const codeToCheck = referralCode || refCode || "";
                      if (codeToCheck) {
                        const valid = await verifyReferralCode(codeToCheck);
                        if (!valid) {
                          setReferralError(
                            "Invalid referral code. Please check and try again.",
                          );
                          return;
                        }
                        setReferralCode(codeToCheck);
                        setReferralError("");
                      }
                      // proceed regardless of whether a code was provided
                      openSubscriptionModal(plan.id);
                    } else if (plan.isPaid) {
                      if (plan.id === "pro-plan") {
                        // Instead of plan.name === "Pro Plan"
                        console.log("Opening Pro Plan subscription modal");
                        openProPlanModal(plan.id); // Pass plan.id instead of plan.name
                      } else {
                        console.log(
                          "Opening regular modal for other paid plan",
                        );
                        setReferralCode("");
                        openModal(plan.id); // Pass plan.id instead of plan.name
                      }
                    }
                  }}
                  disabled={isRegistered || (isFreePlan && freePlanLoading)}
                >
                  {isRegistered
                    ? "Already Registered"
                    : isFreePlan && freePlanLoading
                      ? "Processing..."
                      : plan.cta}
                </button>
                {/* Show referral error below input */}
                {isSoftLaunchVP && referralError && (
                  <div style={{ color: "red", fontSize: 13, marginTop: 4 }}>
                    {referralError}
                  </div>
                )}
                <div
                  style={{
                    fontSize: 11,
                    opacity: 0.7,
                    textAlign: "center",
                    minHeight: isMobile ? 14 : 16,
                    visibility: plan.isPaid ? "hidden" : "visible",
                  }}
                >
                  No credit card required
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Referral Instructions Modal */}
      {referralModalOpen && (
        <div
          style={styles.modalOverlay}
          onClick={() => setReferralModalOpen(false)}
        >
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>
              {t("affiliatePartnerPlan.referralModalTitle")}
            </div>
            <div style={styles.modalMessage}>
              {/* Dummy instructions */}
              <ol
                style={{
                  textAlign: "left",
                  color: gold,
                  fontSize: 14,
                  margin: "0 0 16px 0",
                }}
              >
                <li>{t("affiliatePartnerPlan.referralStep1")}</li>
                <li>{t("affiliatePartnerPlan.referralStep2")}</li>
                <li>{t("affiliatePartnerPlan.referralStep3")}</li>
                <li>{t("affiliatePartnerPlan.referralStep4")}</li>
                <li>{t("affiliatePartnerPlan.referralStep5")}</li>
              </ol>
            </div>
            <button
              style={styles.modalButton}
              onClick={() => setReferralModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Stripe Payment Modal */}
      {modalOpen && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <StripePayment
              id={selectedPlan}
              amount={selectedPlan === "Pro Plan" ? 3.99 : 3.99}
              currency="usd"
              isOpen={modalOpen}
              onClose={closeModal}
              onPaymentSuccess={handlePaymentSuccess}
            />
          </div>
        </div>
      )}

      {/* Stripe Subscription Payment Modal */}
      {subscriptionModalOpen && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <StripeSubscriptionPayment
              id={selectedPlan}
              amount={99}
              currency="usd"
              isOpen={subscriptionModalOpen}
              onClose={closeModal}
              onPaymentSuccess={handleSubscriptionPaymentSuccess}
              planType={selectedPlan}
              referralCode={referralCode} // <-- Add this line
            />
          </div>
        </div>
      )}

      {/* Stripe Pro Plan Payment Modal */}
      {proPlanModalOpen && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <StripeProPlanPayment
              id={selectedPlan}
              amount={3.99}
              currency="usd"
              isOpen={proPlanModalOpen}
              onClose={closeModal}
              onPaymentSuccess={handleProPlanPaymentSuccess}
              planType={selectedPlan}
            />
          </div>
        </div>
      )}

      {/* Simulated Payment Modal */}
      {/* {modalOpen && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>Simulated Payment</div>
            <div style={styles.modalMessage}>
              Simulating payment for: {selectedPlan}
            </div>
            <button
              style={styles.modalButton}
              onClick={() => handlePaymentSuccess(customerID)}
            >
              Confirm Payment
            </button>
          </div>
        </div>
      )} */}

      {/* {modalOpen && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <StripePayment
              id={selectedPlan}
              amount={selectedPlan === "Pro Plan" ? 699 : 699}
              currency="sgd"
              isOpen={modalOpen}
              onClose={closeModal}
              onPaymentSuccess={handlePaymentSuccess}
            />
          </div>
        </div>
      )} */}

      {/* Message Modal */}
      {messageModal.isOpen && (
        <div style={styles.modalOverlay} onClick={closeMessageModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>{messageModal.title}</div>
            <div style={styles.modalMessage}>{messageModal.message}</div>
            <button style={styles.modalButton} onClick={closeMessageModal}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Gem Bonus Comparison Modal */}
      {showGemBonusModal && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10002 }}
          onClick={() => setShowGemBonusModal(false)}>
          <div style={{ backgroundColor: "#1a1a1a", borderRadius: 12, padding: "28px 24px", width: "min(640px, 94vw)", boxShadow: "0 8px 32px rgba(0,0,0,0.45)", border: "1px solid rgba(223,189,105,0.25)", position: "relative" }}
            onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setShowGemBonusModal(false)}
              style={{ position: "absolute", top: 16, right: 16, background: "transparent", border: "none", color: gold, cursor: "pointer", fontSize: "1.1rem" }}
            >
              <FaTimes />
            </button>
            <h3 style={{ color: gold, margin: "0 0 20px", fontSize: "1.2rem", textAlign: "center" }}>
              {t('purchaseCoin.gemBonusTable.title')}
            </h3>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "560px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#c9c9c9" }}>
                    {[
                      t('purchaseCoin.gemBonusTable.priceUsd'),
                      t('purchaseCoin.gemBonusTable.explorer'),
                      t('purchaseCoin.gemBonusTable.ambassador'),
                      t('purchaseCoin.gemBonusTable.plusAmount'),
                      t('purchaseCoin.gemBonusTable.plusPercent'),
                    ].map((heading, idx) => (
                      <th key={idx} style={{ padding: "10px 12px", color: "#151517", fontWeight: 700, fontSize: "0.9rem", textAlign: "center", border: "1px solid #444" }}>
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {gemBonusTableRows.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "8px 12px", color: gold, textAlign: "center", border: "1px solid #444" }}>{row.price}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.explorer}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.ambassador}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.plusAmount}</td>
                      <td style={{ padding: "8px 12px", color: "#fff2d2", textAlign: "center", border: "1px solid #444" }}>{row.plusPercent}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const gemBonusTableRows = [
  { price: "$0.99", explorer: "10 Gem", ambassador: "10 Gem", plusAmount: "--", plusPercent: "0%" },
  { price: "$4.99", explorer: "50 Gem", ambassador: "52 Gem", plusAmount: "+2", plusPercent: "+4%" },
  { price: "$9.99", explorer: "100 Gem", ambassador: "105 Gem", plusAmount: "+5", plusPercent: "+5%" },
  { price: "$49.99", explorer: "500 Gem", ambassador: "530 Gem", plusAmount: "+30", plusPercent: "+6%" },
  { price: "$99.99", explorer: "1,000 Gem", ambassador: "1,070 Gem", plusAmount: "+70", plusPercent: "+7%" },
  { price: "$199.99", explorer: "2,000 Gem", ambassador: "2,150 Gem", plusAmount: "+150", plusPercent: "+7.5%" },
  { price: "$499.99", explorer: "5,000 Gem", ambassador: "5,400 Gem", plusAmount: "+400", plusPercent: "+8%" },
  { price: "$999.00", explorer: "10,000 Gem", ambassador: "10,850 Gem", plusAmount: "+850", plusPercent: "+8.5%" },
  { price: "$4,999.00", explorer: "50,000 Gem", ambassador: "54,500 Gem", plusAmount: "+4,500", plusPercent: "+9%" },
  { price: "$9,999.00", explorer: "100,000 Gem", ambassador: "110,000 Gem", plusAmount: "+10,000", plusPercent: "+10%" },
];

export default RewardsPartner;
